import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const MIN_LOADER_TIME = 600;

// In-memory cache of visited routes
const visitedRoutes = new Set();

export default function RouteLoader({ exclude = [] }) {
  const location = useLocation();
  const [show, setShow] = useState(false);

  const isFirstRender = useRef(true);
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    const currentPath = location.pathname;

    // Skip first render (bootstrap loader handles it)
    if (isFirstRender.current) {
      isFirstRender.current = false;
      visitedRoutes.add(currentPath);
      prevPath.current = currentPath;
      return;
    }

    // Skip same-path navigation (modals, re-clicks)
    if (prevPath.current === currentPath) {
      return;
    }

    // Skip excluded routes (home etc.)
    if (exclude.includes(currentPath)) {
      visitedRoutes.add(currentPath);
      prevPath.current = currentPath;
      return;
    }

    // Skip browser back / forward if already visited
    if (visitedRoutes.has(currentPath)) {
      prevPath.current = currentPath;
      return;
    }

    // FIRST TIME visiting this route → show loader
    prevPath.current = currentPath;
    visitedRoutes.add(currentPath);
    setShow(true);

    const timer = setTimeout(() => {
      setShow(false);
    }, MIN_LOADER_TIME);

    return () => clearTimeout(timer);
  }, [location.pathname, exclude]);

  if (!show) return null;

  return (
    <div className="runtime-loader">
      <div className="loader"></div>
    </div>
  );
}
